import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function ThankYou() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-stone-50 to-stone-100">
      <Navbar />
      
      <main className="pt-32 pb-24 px-6">
        <div className="max-w-3xl mx-auto">
          {/* Success Icon */}
          <div className="flex justify-center mb-8">
            <div className="w-24 h-24 bg-gradient-to-br from-violet-500 to-violet-600 rounded-full flex items-center justify-center animate-bounce">
              <i className="ri-check-line text-5xl text-white"></i>
            </div>
          </div>

          {/* Main Message */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-stone-900 mb-4">
              Thank You — We've Received Your Request!
            </h1>
            <p className="text-lg text-stone-600 max-w-2xl mx-auto">
              Our team will review your information and be in touch shortly to guide you through the next steps.
            </p>
          </div>

          {/* Important Notice */}
          <div className="bg-violet-50 border-2 border-violet-200 rounded-2xl p-8 mb-10">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-violet-600 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-stone-900 mb-2">Check Your Email</h3>
                <p className="text-stone-700 leading-relaxed">
                  You will receive an email from <strong>Therapy Notes</strong>, our patient portal, to complete your registration and schedule your testing. Please check your inbox (and spam folder) within the next 24 hours.
                </p>
              </div>
            </div>
          </div>

          {/* What Happens Next */}
          <div className="bg-white rounded-2xl p-8 shadow-lg mb-10">
            <h2 className="text-2xl font-bold text-stone-900 mb-6 text-center">What Happens Next</h2>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-violet-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold">1</span>
                </div>
                <div>
                  <h4 className="font-semibold text-stone-900 mb-1">Check Your Inbox</h4>
                  <p className="text-stone-600 text-sm">Look for an email from Therapy Notes with your portal registration link.</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-violet-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold">2</span>
                </div>
                <div>
                  <h4 className="font-semibold text-stone-900 mb-1">Register in the Portal</h4>
                  <p className="text-stone-600 text-sm">Complete your secure patient profile and verify your information.</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-violet-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold">3</span>
                </div>
                <div>
                  <h4 className="font-semibold text-stone-900 mb-1">Schedule Your Testing</h4>
                  <p className="text-stone-600 text-sm">Choose a convenient time for your ADHD assessment and begin your journey to clarity.</p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="px-8 py-4 bg-violet-600 text-white rounded-full font-semibold hover:bg-violet-700 transition-colors text-center whitespace-nowrap"
            >
              Return to Home
            </Link>
            <a
              href="https://www.therapyportal.com/p/altalume/"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-white text-violet-600 border-2 border-violet-600 rounded-full font-semibold hover:bg-violet-50 transition-colors text-center whitespace-nowrap"
            >
              Access Client Portal →
            </a>
          </div>

          {/* Additional Info */}
          <div className="mt-12 text-center">
            <p className="text-sm text-stone-500">
              Questions? Contact us at <a href="mailto:support@altalume.com" className="text-violet-600 hover:underline">support@altalume.com</a>
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}